import request from '@/utils/request'
// 新增维修记录
export function addMaintain (data) {
  return request({
    url: '/car/maintain/add',
    method: 'post',
    data
  })
}
// 修改维修记录
export function updateMaintain (data) {
  return request({
    url: '/car/maintain/update',
    method: 'post',
    data
  })
}
// 解决维修记录
export function solveMaintain (data) {
  return request({
    url: '/car/maintain/solve',
    method: 'post',
    data
  })
}
// 查询维修记录
export function getMaintains (data) {
  return request({
    url: '/car/maintain/getMaintains',
    method: 'get',
    params: data
  })
}
// 删除维修记录
export function delMaintains (data) {
  return request({
    url: '/car/maintain/deleteById',
    method: 'post',
    params: data
  })
}
// 维修记录详情
export function getDetail (data) {
  return request({
    url: '/car/maintain/getDetail',
    method: 'get',
    params: data
  })
}